import { Controller } from '@hotwired/stimulus'

export default class ProfileSectionsController extends Controller {
  static targets = ['section'];

  connect() {
    this.refresh();
  }

  refresh() {
    const openSection = this.sectionTargets.find((section) =>
      section.querySelector('form')
    );

    this.sectionTargets.forEach((section) => {
      const inactive = Boolean(openSection) && section !== openSection;

      section.toggleAttribute('inert', inactive);
      section.classList.toggle('opacity-50', inactive);
    });
  }
}
